import { mergeStyleSets, NeutralColors } from '@fluentui/react';

var classNames = mergeStyleSets({
    iconButton: {
        height: '100%',
        color: NeutralColors.gray160
    }
});

export { classNames as default };
